import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterClass,
  CharacterSheetInterface,
} from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import { makeStyles } from "@utilities/theme_utilities";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  char_class: CharacterClass;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CharacterSpellStats({
  character,
  char_interface,
  char_class,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = () => {
    setReloading(true);
  }

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      character.subscription_holder.subscribe("Spells", mounted, recalculated);
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
     
  }, [reloading, setReloading]);
    
  const useStyles = makeStyles()((theme) => {
    const colors = char_util.getColors({ char: character, user: api.user, for_id: char_class.source_id });
    return ({
      root: {
        backgroundColor: colors.backgroundColor !== "" ? colors.backgroundColor : theme.palette.secondary.main,
        color: colors.color !== "" && colors.color !== "Default" ? colors.color : undefined
      },
    });
  });

  const { classes, cx } = useStyles();
  const modifier = char_interface.current_ability_scores.getModifier(char_class.spellcasting_ability);
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 2
        }}>&nbsp;</Grid>
      <Grid
        className={cx(classes.root, "centered")}
        size={{
          xs: 3
        }}>
        { char_class.source && char_class.source.name }
      </Grid>
      <Grid
        className={cx(classes.root, "centered")}
        style={{ fontSize: "13px", fontWeight: "bold" }}
        size={{
          xs: 3
        }}>
        { common_util.addPlusMaybe(modifier) }
      </Grid>
      <Grid
        className={cx(classes.root, "centered")}
        style={{ fontSize: "13px", fontWeight: "bold" }}
        size={{
          xs: 2
        }}>
        { common_util.addPlusMaybe(char_class.spell_attack) }
      </Grid>
      <Grid
        className={cx(classes.root, "centered")}
        style={{ fontSize: "13px", fontWeight: "bold" }}
        size={{
          xs: 2
        }}>
        { char_class.spell_dc }
      </Grid>
    </Grid>
  );
}
